import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import BurgerMenu from './BurgerMenu';

const NAV_ITEMS = [
  { path: '/',         label: 'dashboard', icon: '🏠', exact: true },
  { path: '/purchases',label: 'purchases', icon: '🛒' },
  { path: '/sales',    label: 'sales',     icon: '💰' },
  { path: '/harvest',  label: 'harvest',   icon: '🌾' },
  { path: '/stock',    label: 'stock',     icon: '📦' },
  { path: '/plantings', label: 'plantings', icon: '🌱' },
  { path: '/notebook', label: 'notebook', icon: '📓' },
  { path: '/work-orders', label: 'workOrders', icon: '📋' },
  { path: '/yevmiyeler', label: 'yevmiyeler', icon: '👷' },
  { path: '/payments', label: 'payments',  icon: '💳' },
  { path: '/settings', label: 'settings',  icon: '⚙️' },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="layout">
      {/* Top header */}
      <header className="page-header">
        <button onClick={() => setMenuOpen(true)}
          style={{ background: 'none', border: 'none', color: '#fff', fontSize: '1.3rem', cursor: 'pointer', padding: '0 4px', marginRight: 4 }}>
          ☰
        </button>
        <span style={{ fontSize: '1.4rem' }}>🌱</span>
        <h1>Teldolap</h1>
        <span style={{ fontSize: '0.8rem', opacity: 0.7, marginLeft: 'auto' }}>
          {user?.farmName}
        </span>
        <button
          onClick={() => { logout(); navigate('/login'); }}
          style={{
            background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff',
            borderRadius: '8px', padding: '6px 10px', cursor: 'pointer',
            fontSize: '0.75rem', fontWeight: 700, marginLeft: 8
          }}
        >
          {t('nav.logout')}
        </button>
      </header>
      <BurgerMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      {/* Page content */}
      <main className="page-content">
        <Outlet />
      </main>

      {/* Bottom navigation */}
      <nav className="bottom-nav">
        {NAV_ITEMS.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.exact}
            className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
          >
            <span style={{ fontSize: '1.2rem', lineHeight: 1 }}>{item.icon}</span>
            <span>{t(`nav.${item.label}`)}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
